// extracted by mini-css-extract-plugin
var _1 = "EmailProfileAISummaryWidget-moduleEmailProfileAISummaryWidget__VSIX1 ProfileAISummaryWidget-moduleProfileAISummaryWidget__B5VA7 Widget-moduleWidget__bcnWB";
export { _1 as "EmailProfileAISummaryWidget" }
